import React, { useState, useEffect } from 'react';
import { Link, useLocation, useNavigate } from 'react-router-dom';
import BottomNavigation from '@mui/material/BottomNavigation';
import BottomNavigationAction from '@mui/material/BottomNavigationAction';
import Paper from '@mui/material/Paper';

import img_home from '../../images/common/i_bot_nav_01.svg';
import img_home_on from '../../images/common/i_bot_nav_01_on.svg';
import img_hospitalCare from '../../images/common/i_bot_nav_02.svg';
import img_hospitalCare_on from '../../images/common/i_bot_nav_02_on.svg';
import img_alarm from '../../images/common/i_bot_nav_03.svg';
import img_alarm_on from '../../images/common/i_bot_nav_03_on.svg';
import img_mypage from '../../images/common/i_bot_nav_04.svg';
import img_mypage_on from '../../images/common/i_bot_nav_04_on.svg';

const Navbar = () => {
  const location = useLocation();
  const currentPath = location.pathname;
  const navigate = useNavigate();
  
  // useEffect(() => {
  //   switch (currentPath) {
  //     case '/home-main': setValue(1); break;
  //     case '/health-results': setValue(2); break;
  //     case '/report': setValue(3); break;
  //     case '/health-inform': setValue(4); break;
  //     default: setValue(0);
  //   }
  // }, [currentPath]);

  const handleNav = (to) => {
      navigate(to);
      window.scrollTo(0, 0);
  };

  const navItems = [
    { label: '홈', to: '/home-main', val: 1, icon: img_home, iconOn: img_home_on },
    { label: '검사결과', to: '/health-results', val: 2, icon: img_hospitalCare, iconOn: img_hospitalCare_on },
    { label: '리포트', to: '/report', val: 3, icon: img_alarm, iconOn: img_alarm_on },
    { label: '건강정보', to: '/health-info', val: 4, icon: img_mypage, iconOn: img_mypage_on },
  ];

  const value = navItems.find(item => currentPath.startsWith(item.to))?.val ?? 1;

  return (
    <Paper sx={{ position: 'fixed', bottom: 0, left: 0, right: 0, zIndex: 10, height: 'var(--sp-56)' }} elevation={5}>
      <BottomNavigation
                showLabels
                value={value}

                sx={{
                    '& .MuiBottomNavigationAction-root': {
                        userSelect: 'none !important',
                        WebkitUserSelect: 'none !important',
                        WebkitTouchCallout: 'none !important',
                        WebkitUserDrag: 'none !important',
                    },
                    '& a': {
                        userSelect: 'none !important',
                        WebkitUserSelect: 'none !important',
                        WebkitTouchCallout: 'none !important',
                        WebkitUserDrag: 'none !important',
                    },
                    '& img': {
                        pointerEvents: 'none !important',
                        userSelect: 'none !important',
                        WebkitUserDrag: 'none !important',
                    }
                }}
            >
            {navItems.map((item) => {

                const isActive = value === item.val;

                return (
                    <BottomNavigationAction
                        key={item.val}
                        label={item.label}
                        icon={
                            <span style={{ position: 'relative', width: 24, height: 24 }}>
                                <img
                                    src={item.icon}
                                    draggable={false}
                                    alt=""
                                    style={{
                                        position: 'absolute',
                                        inset: 0,
                                        opacity: isActive ? 0 : 1,
                                        transition: 'opacity 0.15s',
                                    }}
                                />
                                <img
                                    src={item.iconOn}
                                    draggable={false}
                                    alt=""
                                    className={isActive ? "animation-4" : ""}
                                    style={{
                                        position: 'absolute',
                                        inset: 0,
                                        opacity: isActive ? 1 : 0,
                                        transition: 'opacity 0.15s',
                                    }}
                                />
                            </span>
                        }
                        component={Link}
                        to={item.to}
                        value={item.val}
                        onClick={() => handleNav(item.to)}
                    />
                );
            })}
        </BottomNavigation>
    </Paper>
  );
};

export default Navbar;
